import script from "./ContentLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentLayout.vue?vue&type=script&setup=true&lang=ts"

import "./ContentLayout.vue?vue&type=style&index=0&id=780c5086&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780c5086"]])

export default __exports__